import de from "./de.json";
import it from "./it.json";
import en from "./en.json";
export default { de, it, en };
